import {FAILURE, PENDING, SUCCESS} from '../../constants'

const InitialState = {
  data: {},
  error: null,
  isLoading: false,
}

const reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        data: {...state.data, [action.key]: action.payload.fields || []},
      }
    case FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
export {InitialState}
